import { ActionMenuItem } from '../../commons/components/GrowegyMenu';
import { BookIcon } from '../../assets/icons';
import { openUrlInNewTab } from '../../util/window-utils';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';

export const createTutorialsMenuItem = (isHidden: boolean, dataTest?: string): ActionMenuItem => ({
  type: 'standard',
  text: 'Tutorials',
  icon: <BookIcon />,
  isHidden,
  dataTest,
  onClick: () =>
    openUrlInNewTab('https://www.growegy.com/resources/', {
      analyticsEvent: AnalyticsEvent.TUTORIALS_OPENED,
    }),
});
